import { LockOpen } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const LockOpenIcon = createLucideIcon(LockOpen);
